var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.de4f3a49228b6bd11dc5048b9e5fb1fe.svg#bb';
                    var viewUrl = 'sprites.de4f3a49228b6bd11dc5048b9e5fb1fe.svg#view-bb';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 57 37',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };